(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modulo', {
            parent: 'entity',
            url: '/modulo?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'chamadosApp.modulo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modulo/modulos.html',
                    controller: 'ModuloController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modulo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('modulo.new', {
            parent: 'modulo',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modulo/modulo-dialog.html',
                    controller: 'ModuloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricao: null,
                                projetoRedMine: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modulo', null, { reload: 'modulo' });
                }, function() {
                    $state.go('modulo');
                });
            }]
        })
        .state('modulo.edit', {
            parent: 'modulo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modulo/modulo-dialog.html',
                    controller: 'ModuloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modulo', function(Modulo) {
                            return Modulo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modulo', null, { reload: 'modulo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
